import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { MEDIA_FILE_QUERY_PARAM } from "@/components/MediaFileDetailsModal/useMediaFileModalAddress";

// Query params that open an overlay over the page rather than move to another one, so the page keeps its scroll.
const OVERLAY_QUERY_PARAMS = [MEDIA_FILE_QUERY_PARAM];

export const getPageSearch = (search) => {
  const params = new URLSearchParams(search);
  OVERLAY_QUERY_PARAMS.forEach((param) => params.delete(param));
  return params.toString();
};

export default function ScrollToTop({ children }) {
  const { pathname, search } = useLocation();
  const pageSearch = getPageSearch(search);
  const refPrevious = useRef(null);
  useEffect(() => {
    const previous = refPrevious.current;
    refPrevious.current = { pathname, pageSearch };
    // Only a change of the page's own query resets, as it always has: a path change is left to whatever
    // owns that route. An overlay's id is not the page's query, so opening or closing one keeps the place.
    if (previous === null || previous.pageSearch !== pageSearch) {
      document.documentElement.scrollTo(0, 0);
    }
  }, [pathname, pageSearch]);
  return children;
}
